import React, {Component} from 'react';
import styled from "styled-components";

import ExploreTree from "./Explore/ExploreTree";
import ExploreEdit from "./Explore/ExploreEdit";

const ExploreWrapper = styled.div`
    font-family: Arial;
    z-index: 1;
`;

export class AppExplore extends Component {

    state = {
        nodeId: null
    }

    render() {
        return <ExploreWrapper>
            <ExploreTree {...this.props} onSelect={(nodeId) => this.setState({nodeId: nodeId})}/>
            <ExploreEdit {...this.props} nodeId={this.state.nodeId}/>
        </ExploreWrapper>
    }
}

export default AppExplore;
